/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Build_CreateInputs */

const en_nav_build_create = /** @type {(inputs: Nav_Build_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Build`)
};

const es_nav_build_create = /** @type {(inputs: Nav_Build_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva Build`)
};

/**
* | output |
* | --- |
* | "New Build" |
*
* @param {Nav_Build_CreateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const nav_build_create = /** @type {((inputs?: Nav_Build_CreateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Build_CreateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_build_create(inputs)
	return en_nav_build_create(inputs)
});
export { nav_build_create as "nav.build.create" }